module.exports = __webpack_public_path__ + "assets/img/Nexon-1-Landing-Page-w720.2db2157d.jpg";